import React, { useEffect, useState, forwardRef } from 'react';

const PercentageField = forwardRef(({
  fieldName,
  wrapperClass = '',
  label,
  hideLabel = false,
  allowNull = true,
  inputType = 'text',
  value = '',
  step,
  errors = [],
  helpText = '',
  parent = '',
  autofocus = false,
  disabled = false,
  width = '',
  style = {},
  many = false,
  onChange = () =>  {},
  pk = null
}, ref) => {
  const [inputValue, setInputValue] = useState(value);
  const localOnChange = (e) => {
    setInputValue(e.target.value)
    onChange({'name':fieldName, 'value': e.target.value, 'label': e.target.value})
  }
  const onBlur = (e) => {
    // setInputValue(e.target.value)
    // console.log(fieldName, inputValue, e.target.value)
    // onChange({'name':fieldName, 'value': inputValue, 'label': inputValue})
  }
  useEffect(() => {
    setInputValue(value)
  }, [value])
  return <>
  <div class="input-group mb-3">
      <input
        ref={ref}
        id={pk ? pk + '_' + fieldName : fieldName}
        name={fieldName}
        style={{maxWidth: '100px'}}
        className={`form-control ${style.class} ${errors.length > 0 ? 'is-invalid' : ''}`}
        type={inputType}
        step={step}
        placeholder={style.placeholder}
        value={inputValue}
        data-char_select_parent={parent}
        autoFocus={autofocus && inputType !== 'hidden'}
        disabled={disabled}
        onBlur={onBlur}
        onChange={localOnChange}
      />
        <span class="input-group-text bg-light" id="basic-addon1">%</span>

  </div>

    </>
});

export default PercentageField;